import { outcomeIdSchema } from './ids';

/**
 * Member-facing reminder saves. One `attempted` outcome per write before the
 * request is sent, then exactly one `succeeded` or `failed`, so a save that
 * never reaches the server shows up as attempts without a matching settled
 * outcome and the server's `reminder.entry.*` events close the funnel. The
 * `error_code` on a failed outcome is a closed kebab-case classification
 * (`network`, `client-error`, `server-error`, `list-unavailable`,
 * `unknown`) — never response text.
 */
export const REMINDER_SAVE_OUTCOME_IDS = {
  attempted: outcomeIdSchema.parse('reminder.save.attempted'),
  succeeded: outcomeIdSchema.parse('reminder.save.succeeded'),
  failed: outcomeIdSchema.parse('reminder.save.failed'),
} as const;

/** The same lifecycle for the Settings screen's notification-category write. */
export const NOTIFICATION_PREFERENCE_SAVE_OUTCOME_IDS = {
  attempted: outcomeIdSchema.parse('notification.preference-save.attempted'),
  succeeded: outcomeIdSchema.parse('notification.preference-save.succeeded'),
  failed: outcomeIdSchema.parse('notification.preference-save.failed'),
} as const;
